import { inject, injectable } from 'inversify';
import { army_list_unit_formated } from '@Api';
import {
  ArmyListUnit,
  ArmyListUnitFormated,
  ArmyListUnitModelRuleTroop,
  ArmyListUnitTroop,
  TroopCarac,
} from '@Models';
import { TYPES } from '@Types';
import { UnitMapper } from '../../ninthAge/UnitMapper';
import { ArmyListUnitOptionFormatedMapper } from './army-list-unit-option-formated.mapper';

@injectable()
export class ArmyListUnitFormatedMapper {
  @inject(TYPES.UnitMapper) private _unitMapper!: UnitMapper;
  @inject(TYPES.Mapper.ArmyListUnitOptionFormatedMapper)
  private _armyListUnitOptionFormatedMapper!: ArmyListUnitOptionFormatedMapper;

  public map(item: army_list_unit_formated): ArmyListUnitFormated {
    return {
      entry: item.entry,
      name: item.name,
      fixed: item.fixed,
      total: item.total,
      unit: item.unit != null ? this._unitMapper.mapAll(item.unit) : null,
      size: item.size ?? 1,
      points: item.points,
      option:
        item.option != null
          ? this._armyListUnitOptionFormatedMapper.map(item.option)
          : null,
      organisationId: item.principal_organisation_id,
    } satisfies ArmyListUnitFormated as ArmyListUnitFormated;
  }

  public mapToBuilder(item: ArmyListUnitFormated, index: number): ArmyListUnit {
    return {
      id: '',
      syncId: null,
      errorSync: false,
      organisation_id: item.organisationId!,
      points: item.total!,
      size: item.size,
      position: index,
      is_enabled: true,
      unit_id: item.unit!.id,
      unitName: item.unit!.name,
      isDeleted: false,
      name: item.name ?? '',
      notes: null,
      magic: null,
      army_list_unit_unit_options: (item.option?.options ?? [])
        .filter((option) => option.unitOptionId != null)
        .flatMap((option) => {
          return this._armyListUnitOptionFormatedMapper.mapToBuilder(option);
        }),
      troops: item.unit!.troops.map(
        (troop) =>
          ({
            id: '',
            name: troop.name,
            position: troop.position,
            troopId: troop.id,
            size: 0,
            points: 0,
            carac: {
              ...troop.carac,
            } satisfies TroopCarac as TroopCarac,
          }) satisfies ArmyListUnitTroop as ArmyListUnitTroop,
      ),
      modelRuleUnitTroops: new Array<ArmyListUnitModelRuleTroop>(),
      carac: item.unit!.carac,
      organisations: [],
      mountId: null,
      mount: null,
      updatedAt: 0,
    } satisfies ArmyListUnit as ArmyListUnit;
  }
}
